export default "/images/vendor/flag-icon-css/flags/1x1/ki.svg?32000b051bb6bb9ee78500c639023c1a";